import React, { Fragment } from 'react';
import { bool, func } from 'prop-types';
import Radium from 'radium';
import { UTButton, UTLabel } from '@widergy/energy-ui';

import UTBullet from 'app/components/UTBullet';
import { appConfig } from 'config/customization';
import { UTILITIES } from 'constants/utilitiesMappers';
import { message } from 'utils/stringUtils';

import QueryModal from './components/QueryModal';
import EdenContentLayout from './components/EdenContentLayout';
import styles from './styles';
import cssStyles from './styles.module.scss';

function SocialRateScene({ onQueryButtonClick, onGoToHome, ...props }) {
  return (
    <Fragment>
      {appConfig.mappers === UTILITIES.eden ? (
        <EdenContentLayout />
      ) : (
        appConfig.socialRate.content.map(content => (
          <React.Fragment key={content.key}>
            {content.title && (
              <UTLabel bold className={cssStyles.title}>
                {content.title}
              </UTLabel>
            )}
            {content.subtitle && (
              <UTLabel className={cssStyles.subtitle} light small style={styles.subtitle}>
                {content.subtitle}
              </UTLabel>
            )}
            <div>
              {content.items &&
                (content.withBullet
                  ? content.items.map(item => (
                      <UTBullet content={item.content} base key={item.id} style={styles.bullets} />
                    ))
                  : content.items.map(item => (
                      <div key={item.id} style={styles.itemContentContainer}>
                        <UTLabel black light small>
                          {item.content}
                        </UTLabel>
                      </div>
                    )))}
            </div>
          </React.Fragment>
        ))
      )}
      <div style={styles.buttonsContainer}>
        {appConfig.socialRate.showCancelButton && (
          <UTButton secondary onPress={onGoToHome} style={{ ...styles.button, ...styles.cancel }}>
            {message('Commons:cancel')}
          </UTButton>
        )}
        <UTButton onPress={onQueryButtonClick} style={styles.button}>
          {message('SocialRate:queryButton')}
        </UTButton>
      </div>
      <QueryModal {...props} />
    </Fragment>
  );
}

SocialRateScene.propTypes = {
  onQueryButtonClick: func.isRequired,
  closeModal: func.isRequired,
  handleSubmit: func.isRequired,
  modalIsOpen: bool.isRequired,
  socialRateQuery: func.isRequired,
  onGoToHome: func.isRequired
};

export default Radium(SocialRateScene);
